/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="item-position project-alarm" :style="isXL ? {top: '253px'} : {}">
    <div class="title-item">
      <div class="first"></div>
      <div class="two">05</div>
      <div class="title">
        <div>Risk Details</div>
        <div>风险详情</div>
      </div>
    </div>
    <div class="alarm-title">
      <div :class="{'click':isRunInfo === 1}" @click="itemClick(1)">高危风险</div>
      <div :class="{'click':isRunInfo === 2}" @click="itemClick(2)">低危风险</div>
      <div :class="{'click':isRunInfo === 3}" @click="itemClick(3)">机体风险</div>
    </div>
    <div class="alarm-split" />
    <div class="alarm-content" v-if="isRunInfo === 1">
      <div class="info-item" v-for="(item,index) of behaviorHighList" :key="index">
        <div class="title">{{item.subRiskTypeName}}</div>
        <div class="content">{{item.riskNum}}</div>
      </div>
    </div>
    <div class="alarm-content" v-if="isRunInfo === 2">
      <div class="info-item" v-for="(item,index) of behaviorLowList" :key="index">
        <div class="title">{{item.subRiskTypeName}}</div>
        <div class="content">{{item.riskNum}}</div>
      </div>
    </div>
    <div class="alarm-content" v-if="isRunInfo === 3">
      <div class="info-item" v-for="(item,index) of bodyRiskList" :key="index">
        <div class="title">{{item.subRiskTypeName}}</div>
        <div class="content">{{item.riskNum}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'realRiskDetail',
  data () {
    return {
      isRunInfo: 1
    }
  },
  props: {
    bodyRiskList: {
      type: Array
    },
    behaviorHighList: {
      type: Array
    },
    behaviorLowList: {
      type: Array
    },
    isXL: {
      type: Boolean
    }
  },
  methods: {
    itemClick (type) {
      this.isRunInfo = type
    }
  }
}
</script>

<style scoped lang="scss">
.project-alarm{
  z-index: 2;
  left: 1539px;
  top: 300px;
  width: 362px;
  .alarm-title{
    display: flex;
    justify-content: space-between;
    color:rgba(255,255,255,0.3);
    div{
      flex: 1;
      height:26px;
      background-color: rgba(4,30,48,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor:pointer;
    }
    .click{
      color: #15c5e8 !important;
      border-bottom:  1px solid #15c5e8 !important;
    }
  }
  .alarm-split{
    margin-top: 9px;
  }
  .alarm-content{
    background-color: rgba(4,30,48,0.5);
    width:100%;
    height:420px;
    font-size: 14px;
    margin-top: 6px;
    overflow: auto;
    .info-item{
      height:46px;
      width:100%;
      display: flex;
      align-items: center;
      padding:0 5px;
      color: #fff;
      .title{
        width:200px;
        text-align: center;
      }
      .content{
        text-align: center;
        width:210px;
      }
    }
    .info-item:nth-child(odd){
      background-color:rgba(8,43,65,0.5)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RealRiskDetail.vue